var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomTooltip', {
    attrs: {
      "customClass": _vm.$props.customsClasses
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$props.tooltip) + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }